import type { IconProps } from "types";
import DocoonLogo from "../docoon.png";

const DocoonIcon = ({ className }: IconProps) => {
    return <img src={DocoonLogo} className={className ?? "docoon-logo"} alt="Docoon" />;
};

export default DocoonIcon;
